import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { TENANT } from '../Tenant.enum';
import { TenantService } from './tenant.service';

@Injectable({
  providedIn: 'root'
})
export class TenantGuard implements CanActivate {
  private readonly router = inject(Router);
  private readonly tenantService = inject(TenantService);

  private readonly unauthorizedUrl = '/unauthorized';

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const allowedTenants: TENANT[] = route.data?.tenantsAllowed ?? [];
    const isAllowed = allowedTenants.includes(this.tenantService.currentTenant());

    if (!isAllowed) {
      void this.router.navigate([this.unauthorizedUrl]);
    }

    return isAllowed;
  }
}
